export const schemas: Record<string, string[]> = {
  ocean: ['#008E1B', '#009155', '#009187', '#008EB1', '#006872', '#2F4858'],
  sunset: ['#ae76de', '#D65DB1', '#FF6F91', '#FF9671', '#FFC75F', '#F9F871'],
  red: ['#dc143c', '#ff2400', '#800020', '#b22222', '#e52b50', '#ff7f50'],
  orange: ['#F76E11', '#FF9F45', '#FFBC80', '#FC4F4F', '#eb9605', '#964000'],
  green: ['#a4de02', '#76ba1b', '#4c9a2a', '#acdf87', '#68bb59', '#1e5631'],
  blue: ['#00496C', '#45bdee', '#28a7ea', '#006cbb', '#034698', '#032f64'],
  violet: ['#80007e', '#a02d9c', '#c37ecd', '#9e5fb8', '#7f3e98', '#4c197f'],
  turquoise: ['#0ddbcc', '#43ebff', '#19ceeb', '#28acea', '#388ee9', '#3d76e0'],
  yellow: ['#fff700', '#ffff9f', '#fef54f', '#f9e231', '#f6c616', '#eab200'],
  grey: ['#b1b5ba', '#d2d5d6', '#dee0e0', '#bdbdbb', '#9fa19c', '#686e67'],
};
